import { Reducer } from 'redux';

import { switchCurrentMarket } from './currentMarket';

// Actions

export const openMarketsSidebar = () => ({
  type: 'OPEN_MARKETS_SIDEBAR' as const,
});

export const closeMarketsSidebar = () => ({
  type: 'CLOSE_MARKETS_SIDEBAR' as const,
});

type MarketsSidebarAction = ReturnType<
  | typeof openMarketsSidebar
  | typeof switchCurrentMarket
  | typeof closeMarketsSidebar
>;

// Reducer

interface MarketsSidebarState {
  readonly isOpened: boolean;
}

const defaultState: MarketsSidebarState = { isOpened: false };

export const marketsSidebarReducer: Reducer<
  MarketsSidebarState,
  MarketsSidebarAction
> = (state = defaultState, action): MarketsSidebarState => {
  switch (action.type) {
    case 'OPEN_MARKETS_SIDEBAR':
      return {
        isOpened: true,
      };
    case 'CLOSE_MARKETS_SIDEBAR':
      return {
        isOpened: false,
      };
    case 'SWITCH_MARKET':
      return {
        isOpened: false,
      };
    default:
      return state;
  }
};
